
import { openMembershipModal } from '@/helpers/ModalDialogs'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class MembershipModalStory extends Vue {
  mounted() {
    openMembershipModal()
  }
}
